<template>
  <v-card variant="outlined" class="metric-tile">
    <v-card-title>
      <div class="d-flex justify-space-between align-center">
        Details
        <v-btn variant="text" @click="$emit('editClicked')">Edit</v-btn>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list>
        <v-list-item>
          <v-list-item-title>
            Title
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ tenant.title }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            Country
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ country }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            Slug
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ tenant.slug }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-divider />
  </v-card>
</template>

<script lang="ts" setup>
import {computed, PropType} from "vue";
import {Tenant} from "@YenzaCT/sdk";
import {countryOptions} from "@/lib/appConfiguration";

const props = defineProps({
  tenant: {
    type: Object as PropType<Tenant>,
    required: true
  }
});

const country = computed(() => countryOptions.find((c) => c.value === props.tenant.country)?.title);
</script>
